import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';

import { FormattedCurrency } from '@/components/Formatted/FormattedCurrency';
import { useAppSelector } from '@/redux/hooks';
import { getCatalogBuyersPremium, getCatalogCurrency } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { NewAccountWalkthroughSteps } from '@/types/walkthroughs';

import { DescriptionSection } from '../../../DescriptionSection/DescriptionSection';

type Props = {
    catalogId: number;
    /** Add walkthrough DOM node */
    walkthrough?: boolean;
};

export const BuyersPremium = ({ catalogId, walkthrough }: Props) => {
    const { high, low, lowCutoff, middle, middleCutoff } = useAppSelector((state) =>
        getCatalogBuyersPremium(state, catalogId)
    );

    const currency = useAppSelector((state) => getCatalogCurrency(state, catalogId));

    return (
        <DescriptionSection
            body={
                <ul className="m-0 list-none p-0 print:my-2">
                    {!(low && lowCutoff) && !middle && !high && (
                        <li className="flex">
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.lowPercentage"
                                values={{ low }}
                            />
                        </li>
                    )}
                    {low && lowCutoff && (
                        <li className="flex [&_>_div]:ml-[6px]">
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.lowCutOff"
                                values={{ low }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={lowCutoff}
                            />
                        </li>
                    )}
                    {middle && middleCutoff && (
                        <li className="flex [&_>_div]:ml-[6px]">
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.middleCutOff"
                                values={{ middle }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={middleCutoff}
                            />
                        </li>
                    )}
                    {middle && !middleCutoff && (
                        <li className="flex [&_>_div]:ml-[6px]">
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.middleLowCutOff"
                                values={{ middle }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={lowCutoff}
                            />
                        </li>
                    )}
                    {high && (
                        <li className="flex [&_>_div]:ml-[6px]">
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.highCutOff"
                                values={{ high }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={middleCutoff}
                            />
                        </li>
                    )}
                </ul>
            }
            className="mb-lg"
            header="bidding_console.console.currentLiveItem.headers.buyersPremium"
            walkthroughStep={walkthrough ? NewAccountWalkthroughSteps.Item5 : undefined}
        />
    );
};
